import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.0025 18.9999L2.50391 11.4999L4.00126 9.99864L10.0025 16.0599L19.5029 6.49609L21.0029 7.99609L10.0025 18.9999Z"
        fill="currentColor"
      />
    </svg>
  )
}
